import React, { Component } from 'react';
import classNames from 'classnames'
import styles from './index.css';
import PAA from '../../blocks/PhoneAndAddress';
import Title from '../../blocks/Title'
import {LangChangeEventContext} from '../../contexts/LangContext';
// import IMGS from './imgs.json';

import MyGallery from '../../blocks/MyGallery'

export default class Gallery extends Component {
  state={
    modelOpen: false,
    img    :'',
    isActive: 0
  }
  componentWillMount(){
  }
  componentDidMount(){
    this.props.getHeightContent(this.gcBody.offsetHeight,this.grBody.offsetHeight);
  }
  getArrayImages(){
    let arrImg = JSON.parse(this.props.data.gal2).concat(JSON.parse(this.props.data.gal1));
    let arrImgValue = [];

    for (let i = 0, k = arrImg.length; i < k; i++) {
      arrImgValue.push(arrImg[i].image);
    }

    return arrImgValue;
  }
  openModal = t => e =>{
    this.setState({
      modelOpen: true,
      isActive: t,
      img:t
    });
  }
  closeModal =()=>{
    this.setState({
      modelOpen: false
    });
  }
  nextActive = num =>{
    this.setState({
      isActive: num
    });
  }
  render() {
    return (
      <LangChangeEventContext.Consumer>
        {({lang}) =>(
            <div className={classNames(styles['galleryBody'], 
              this.props.steps[1] && styles['is-step1'], 
              this.props.steps[2] && styles['is-step2'], 
              this.props.steps[3] && styles['is-step3'], 
              this.props.steps[4] && styles['is-step4'], 
              this.props.steps[5] && styles['is-step5'], 
              this.props.steps[6] && styles['is-step6'], 
              this.props.steps[7] && styles['is-step7'], 
              this.props.steps[8] && styles['is-step8'], 
              this.props.steps[9] && styles['is-step9'])
            } >  
              <div className={classNames(styles['backgroundImgWrapper'])} >
                <img alt="" src={this.props.data.bg} className={styles['backgroundImg']} />
                <div className={classNames(styles['backgroundGradient'])} ></div>
                <div className={classNames(styles['backgroundLogoWrapper'])} >
                  <img alt="" src="/assets/logo.jpg" className={styles['backgroundLogoImg']} />
                </div>
              </div>
              
              <MyGallery 
                images      = {this.getArrayImages()}
                isActive    = {this.state.isActive}
                nextActive  = {this.nextActive}
                isOpen      = {this.state.modelOpen}
                isClose     = {this.closeModal}
                ADMIN_URL   = {this.props.ADMIN_URL}
              />

              <div className={classNames(styles['contentWrapper'])} style={{transform:'translateY('+this.props.valueScroll+'px)'}}>
                <div className={classNames(styles['header'])}>
                  <PAA classStyle={styles['paaStyle']} 
                    iconPlace= {(this.props.steps[10] && this.props.steps[4]) ? 'place':'place-dark'}
                    iconPhone= {(this.props.steps[10] && this.props.steps[4]) ? 'phone':'phone-dark'}
                    colorStyle={(this.props.steps[10] && this.props.steps[4]) ? "black":""}/>
                  <Title classStyle={styles['titleStyle']} colorStyle="black1"  title={lang.t('galleryHeader')} text={lang.t('gallerySubHeader')}/>
                </div>
                <div className={classNames(styles['content'])}>  
                  <div className={styles['galleryCenter']} ref={item => {this.gcBody = item}}>
                    {JSON.parse(this.props.data.gal2).map((item,i)=>{
                       return(
                        <div className={styles['galleryCenterImgWrapper']} key={i} onClick={this.openModal(i)} >
                          <img alt="" src={this.props.ADMIN_URL+item.image} className={styles['galleryCenterImg']} />
                        </div>
                        )
                    })}
                  </div>
                  <div className={styles['galleryRight']} ref={item => {this.grBody = item}}>
                    {JSON.parse(this.props.data.gal1).map((item,i)=>{
                      let k = i + JSON.parse(this.props.data.gal2).length;
                      return(
                        <div className={styles['galleryRightImgWrapper']} key={i} onClick={this.openModal(k)}>
                          <img alt="" src={this.props.ADMIN_URL+item.image} className={styles['galleryRightImg']} />
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
        )}
      </LangChangeEventContext.Consumer>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Gallery/index.js